import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home'; 
import BachatKhata from './pages/BachatKhata' 
import MudatThev from './pages/MudatThev';
import DamdupatThev from './pages/DamdupatThev';
import SoneTaranKarj from './pages/SoneTaranKarj';
import VahanTaranKarj from './pages/VahanTaranKarj';
import MortgageKarj from './pages/MortgageKarj';
import GrahKarj from './pages/GrahKarj';
import SabhasadKarj from './pages/SabhasadKarj';
import About from './pages/About';
import DirectorsMessage from './pages/DirectorsMessage';
import PhotoGallery from './pages/PhotoGallery';
import Certificate from './pages/Certificate';
import NoticePopup from './pages/NoticePopup';
import Contact from './pages/Contact';
import SevaPage from './pages/SevaPage';












function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/bachat-khata" element={<BachatKhata />} />
        <Route path="/mudat-thev" element={<MudatThev />} />
       <Route path="/damdupat-thev" element={<DamdupatThev />} />
       <Route path="/sone-taran-karj" element={<SoneTaranKarj />} />
       <Route path="/vahan-taran-karj" element={<VahanTaranKarj />} />
       <Route path="/mortgage-karj" element={<MortgageKarj />} />
       <Route path="/grah-karj" element={<GrahKarj />} />
       <Route path="/sabhasad-karj" element={<SabhasadKarj />} />
       <Route path="/about" element={<About />} />
       <Route path="/directors-message" element={<DirectorsMessage />} />
       <Route path="/Photo Gallery" element={<PhotoGallery />} />
       <Route path="/certificate" element={<Certificate />} />
       <Route path="/Contact" element={<Contact/>}/>
      <Route path="/SevaPage" element={<SevaPage/>}/>











      </Routes>
      {/* <NoticePopup/> */}
      <Footer />
    </Router>
  );
}

export default App;
